module.exports = __webpack_public_path__ + "img/tank-turret.d81d6dad.png";